import { render, staticRenderFns } from "./DeleteMessage.vue?vue&type=template&id=3364bf2d&"
import script from "./DeleteMessage.vue?vue&type=script&lang=js&"
export * from "./DeleteMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports